// Guide ids derive from the same stable screen keys the sidebar uses
// (getMenuLeafKey): datasetId | form:<formId> | app:<appId>. Files cannot carry
// a colon, so guide ids use a dash.
export const guideIdForMenuLeafKey = (leafKey: string): string => {
  if (leafKey.startsWith('form:')) return `form-${leafKey.slice('form:'.length)}`;
  if (leafKey.startsWith('app:')) return `app-${leafKey.slice('app:'.length)}`;
  return leafKey;
};

export const guideIdForScreen = (params: {
  datasetId?: string | null;
  formId?: string | null;
  appId?: string | null;
}): string | null => {
  if (params.datasetId) return params.datasetId;
  if (params.formId) return `form-${params.formId}`;
  if (params.appId) return `app-${params.appId}`;
  return null;
};

/**
 * Derives the guide id of the screen behind a router pathname. Mirrors the
 * route shapes in useRoutes (dataset/:datasetId..., form/:formId/..., application/:appId).
 */
export const guideIdForPathname = (
  pathname: string,
  urlPrefix: string
): string | null => {
  let relative = pathname;
  if (urlPrefix && relative.startsWith(urlPrefix)) {
    relative = relative.slice(urlPrefix.length);
  }
  relative = relative.replace(/^\/+/, '');
  const segments = relative.split('/').filter(Boolean).map(decodeURIComponent);
  if (segments[0] === 'dataset' && segments[1]) {
    return guideIdForScreen({ datasetId: segments[1] });
  }
  if (segments[0] === 'form' && segments[1]) {
    return guideIdForScreen({ formId: segments[1] });
  }
  if (segments[0] === 'application' && segments[1]) {
    return guideIdForScreen({ appId: segments[1] });
  }
  return null;
};
